import { detect } from 'detect-browser';

type Browser = { name?: string };
const browser: Browser = detect() || {};

// FF Theme
export const FFTheme = {
    defaultGray: '#494949',
    placeholderGray: '#8a97a0',
    oldDefaultGray: '#6d767d',
    darkText: '#222',
    blue: '#3498db',
    blueHover: '#42abe5',
    blueHighlight: '#f3faff',
    brightBlue: '#3fb2ff', // Used for darker backgrounds like subpage headers
    brightBlueHover: '#50c3ff',
    grayHover: 'rgba(244,246,248,.7)',
    green: '#7bc34e',
    greenHover: '#8cd360',
    greenDark: '#599632',
    orange: '#e67e22',
    orangeHover: '#f59846',
    red: '#e94b35',
    redHover: '#f75c46',
    yellow: '#f6a623',
    yellowHover: '#fbaf33',
    disabledGray: '#b4b4b4',
    backgroundDarkest: '#1e374f',
    backgroundDark: '#32495f',
    backgroundSubPageHeader: '#344a61',
    backgroundLightGray: '#eff1f3',
    borderNormal: '#e5e5e5',
    borderHeader: '#475b6f',
    placeholder: '#d0d0d0',
    fontHeading: '"HelveticaNeue", Helvetica, sans-serif',
    fontSpecial: '"HelveticaNeue", Helvetica, sans-serif',
    fontDefault: '"HelveticaNeue", Helvetica, sans-serif',
    browser: browser,
    vfrGreen: '#07c502',
    mvfrBlue: '#236ed8',
    ifrRed: '#ff2700',
    lifrMagenta: '#ff40ff',
    white: '#ffffff',
    boxShadow100: '0 2px 3px rgba(0, 0, 0, 0.15)',
    divider: '#DDD',
};

export type FFWebTheme = typeof FFTheme;

export default FFTheme as FFWebTheme;
